import Table from "components/data/Table";
import { useEventColumns, useEventList } from "views/Events/EventList/hooks";

interface ConnectedEventListProps {
  templateId?: number;
}

const ConnectedEventList = ({ templateId }: ConnectedEventListProps) => {
  const { dataSource, loading, pagination, onChange } = useEventList({
    options: { templateId },
  });
  const { columns } = useEventColumns();

  return (
    <Table
      rowKey="id"
      {...{ dataSource, pagination, columns, loading, onChange }}
    />
  );
};

export default ConnectedEventList;
